module.exports = __webpack_public_path__ + "img/cover1.60b12d3d.jpg";